<template lang="pug">
.item.d-flex.flex-lg-row
  img.flex-shrink-0(:src="item.Image")
  .content.i_ml_6.i_ml_md_0.i_ml_sm_6.i_ml_md_2.i_mt_sm_0
    h5 {{ item.Title }}
    p.i_body_l {{ item.Content }}
    a.d-inline-block(
      v-if="item.ContactUrl && item.ContactUrl != ''",
      :href="item.ContactUrl"
    )
      .see_more_btn 聯絡專人
    a.d-inline-block.i_ml_4(
      v-if="item.InsuredUrl && item.InsuredUrl != ''",
      :href="item.InsuredUrl"
    )
      .see_more_btn 網路投保
</template>

<script>
export default {
  name: "Item",
  props: {
    item: Object,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/product_combo/item";
</style>
